import React, { useState, useEffect, useRef } from "react";
import { func, bool, array, object, string } from "prop-types";
import { connect } from "react-redux";
import get from "lodash/get";
import { Link } from "@quintype/components";
import Cookies from "universal-cookie";

import HamburgerIcon from "../../atoms/icons/hamburger";
import NavbarSearch from "../NavbarSearch";
import DesktopLogo from "../../atoms/DesktopLogo";
import MobileLogo from "../../atoms/MobileLogo";
import Dropdown from "../../atoms/Dropdown";
import SearchIcon from "../../atoms/icons/search-icon";
import { listValue } from "../../utils/constant";
import VerticalMenubar from "../VerticalMenubar";
import Icon from "../../icons";
import AuthView from "../../rows/AuthView";
import Notifications from "../Notifications";
import { Twitter, Facebook } from "../../atoms/icons/StoryPageIcons";

import { useDeviceWidth, useStyleMenubar, logoRenderer } from "../../utils/react-utils";
import { setVerticalMenuBar } from "../../helper/actions";
import { staticTexts } from "../../utils/Translate";
import { pushEngage } from "../../helper/api";

import "./headerTopContent.m.css";

const HeaderTopContent = ({
  setVerticalMenuBar,
  isVerticalMenubar,
  domainInfo,
  domainSlug = "",
  hamburgerMenu,
  publisherAttributes,
  pushEngageApiKey
}) => {
  const [isDesktop, setIsDesktop] = useState(false);
  const [showSearchIcon, setShowSearchIcon] = useState(true);
  const [showNotifications, setShowNotifications] = useState(false);
  const [notifications, setNotifications] = useState([]);
  const [dot, setDot] = useState(false);
  const ref = useRef(null);
  const cookies = new Cookies();
  const handleClickOutside = event => {
    if (ref.current && !ref.current.contains(event.target)) {
      setShowSearchIcon(true);
    }
  };

  const fetchNotifications = () => {
    const offset = 0;
    const limit = 4;

    pushEngage(offset, limit, pushEngageApiKey).then(resp => {
      setNotifications(resp);
      if (cookies.get("notifications") && resp.length > 0) {
        resp[0].notification_id !== cookies.get("notifications") ? setDot(true) : setDot(false);
      } else {
        setNotifications(resp);
        resp.length > 0 && setDot(true);
      }
    });
  };

  useEffect(() => {
    document.addEventListener("click", handleClickOutside, true);
    return () => {
      document.removeEventListener("click", handleClickOutside, true);
    };
  });

  useEffect(() => {
    fetchNotifications();
    const interval = setInterval(() => {
      fetchNotifications();
    }, 150000);

    return () => clearInterval(interval);
  }, []);

  useDeviceWidth(setIsDesktop);
  useStyleMenubar(isVerticalMenubar);

  const toggleSearchIcon = () => setShowSearchIcon(!showSearchIcon);
  const toggleVerticalMenubar = () => setVerticalMenuBar(!isVerticalMenubar);

  const getWidth = () => {
    switch (domainSlug) {
      case "kishoralo":
        return 160;
      case "bondhushava":
        return 226;
      case "biggan-chinta":
        return 154;
      case "bigganchinta":
        return 154;
      default:
        return 230;
    }
  };

  const getHeight = () => {
    switch (domainSlug) {
      case "kishoralo":
        return 80;
      case "bondhushava":
        return 61;
      case "biggan-chinta":
        return 38;
      case "bigganchinta":
        return 38;
      default:
        return 55;
    }
  };

  const toggleNotifications = () => {
    if (!showNotifications) {
      cookies.set("notifications", notifications.length && notifications[0].notification_id);
      setDot(false);
    }

    setShowNotifications(!showNotifications);
  };

  const getDateFromUtils = () => {
    const currentDate = new Date();
    const year = currentDate.toLocaleString(publisherAttributes.lang === "bn" ? "bn-BN" : "en", { year: "numeric" });
    const weekday = currentDate.toLocaleString(publisherAttributes.lang === "bn" ? "bn-BN" : "en", { weekday: "long" });
    const month = currentDate.toLocaleString(publisherAttributes.lang === "bn" ? "bn-BN" : "en", { month: "long" });
    const day = currentDate.toLocaleString(publisherAttributes.lang === "bn" ? "bn-BN" : "en", { day: "numeric" });

    return (
      <React.Fragment>
        <span styleName="weekday">{weekday}, </span>
        <span>
          {day} {month} {year}
        </span>
      </React.Fragment>
    );
  };

  return (
    <div styleName="base">
      <div
        styleName={`wrapper ${domainInfo && domainInfo.className ? domainInfo.className : ""} ${
          domainSlug === "kishoralo" && isVerticalMenubar ? "kishoralo-hamburger" : ""
        } ${domainSlug === "protichinta" && isVerticalMenubar ? "protichinta-hamburger" : ""}`}
        className="header-top-content"
      >
        <div>
          <div styleName="hamburger-search-wrapper" className="hamburger-search-wrapper">
            {!isVerticalMenubar && (
              <HamburgerIcon
                onMenuToggle={toggleVerticalMenubar}
                isNavbarOpen={isVerticalMenubar}
                isDesktop={isDesktop}
              />
            )}
            {isDesktop && showSearchIcon && (
              <span className="search-icon" styleName="search-icon" onClick={toggleSearchIcon}>
                <SearchIcon domainSlug={domainSlug} />
              </span>
            )}
            {isDesktop && <span ref={ref}>{!showSearchIcon && <NavbarSearch />}</span>}
          </div>
          {isDesktop && !domainSlug && (
            <div>
              <time styleName={`date ${publisherAttributes.lang === "en" ? "en-date" : ""}`}>{getDateFromUtils()}</time>
            </div>
          )}
          {isDesktop && domainSlug === "nagorik-sangbad" && (
            <div>
              <time styleName={`date ${publisherAttributes.lang === "en" ? "en-date" : ""}`}>{getDateFromUtils()}</time>
            </div>
          )}
        </div>
        <div styleName="logo logo-desktop">{logoRenderer(<DesktopLogo width={getWidth()} height={getHeight()} />)}</div>
        <div styleName={`logo logo-mobile ${isVerticalMenubar ? "vertical-menu-bar-logo" : ""}`}>
          {logoRenderer(<MobileLogo width={getWidth()} height={getHeight()} />)}
        </div>
        <div styleName="login-wrapper">
          <div styleName="bell-button">
            {domainSlug === "protichinta" && isDesktop && (
              <span styleName="protichinta-icons">
                {showSearchIcon && (
                  <span styleName="search-icon" onClick={toggleSearchIcon}>
                    <SearchIcon domainSlug={domainSlug} width="18" height="18" />
                  </span>
                )}
                {!showSearchIcon && <NavbarSearch />}
                <Link href="https://www.facebook.com/Protichinta/">
                  <Facebook color1="#fbf6de" color2="#555555" />
                </Link>
                <Link href="https://twitter.com/Protichinta">
                  <Twitter color1="#fbf6de" color2="#555555" />
                </Link>
              </span>
            )}
            <div styleName={`bell-container ${dot ? "new-notifications" : "no-notifications"}`}>
              <span styleName="bell" onClick={() => toggleNotifications()}>
                {" "}
                <Icon type="bell" className="bell" />
              </span>
              {showNotifications && <Notifications closeView={toggleNotifications} notifications={notifications} />}
            </div>
            {publisherAttributes.showLogin && <AuthView />}
          </div>
          {isDesktop && !domainSlug && (
            <Dropdown label={`${staticTexts(publisherAttributes.lang).edition}:`} list={listValue} />
          )}
        </div>
        {!isDesktop && <NavbarSearch device="mobile" />}
      </div>
      {isVerticalMenubar && (
        <VerticalMenubar
          isVerticalMenubar={isVerticalMenubar}
          isDesktop={isDesktop}
          domainInfo={domainInfo}
          toggleVerticalMenubar={toggleVerticalMenubar}
          hamburgerMenu={hamburgerMenu}
        />
      )}
    </div>
  );
};

HeaderTopContent.propTypes = {
  setVerticalMenuBar: func,
  isVerticalMenubar: bool,
  menu: array,
  hamburgerMenu: array,
  domainInfo: object,
  domainSlug: string,
  publisherAttributes: object,
  pushEngageApiKey: string
};

const mapStateToProps = state => {
  return {
    isVerticalMenubar: get(state, ["settingsReducer", "isVerticalMenubar"], false),
    domainSlug: get(state, ["qt", "domainSlug"]),
    publisherAttributes: get(state, ["qt", "config", "publisher-attributes"], {}),
    pushEngageApiKey: get(state, ["qt", "config", "publisher-attributes", "push_engage_api_key"], null)
  };
};

const mapDispatchToProps = dispatch => ({
  setVerticalMenuBar: flag => dispatch(setVerticalMenuBar(flag))
});

export default connect(mapStateToProps, mapDispatchToProps)(HeaderTopContent);
